import styled from 'styled-components';

export const Heading = styled.h2`
  line-height: ${({ size }) => (size === 's' ? '22px' : 'm' ? '36px' : 'l' ? '48px' : size)};
  font-size: ${({ size }) => (size === 's' ? '18px' : 'm' ? '24px' : 'l' ? '36px' : size)};
  font-family: ${({ altFont }) => (altFont ? 'Roboto' : 'Noto Sans')};
  font-weight: ${({ weight }) => (weight ? weight : '700')};
  color: ${({ theme, color }) => (color ? color : theme.black)};
`